module.exports = __webpack_public_path__ + "img/3.bc9ce94d.png";